export default function getCouponReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_COUPON_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_COUPON_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_COUPON_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}